import { IRun } from '../interfaces/run';
import API from './base';

export const runAPI = new API('/runs');

export const getRunReports = (params?: any): Promise<IRun[]> => {
	return runAPI.post<null, IRun[]>('search', params).then(response => response);
};
